module.exports = ".radio-container {\n  text-align: left; }\n\n.mat-radio-button {\n  color: #777777;\n  font-family: Roboto;\n  font-size: 12px;\n  font-weight: 400;\n  margin-right: 10px; }\n\n:host ::ng-deep .mat-radio-outer-circle {\n  border-width: 1px; }\n\n:host ::ng-deep .mat-radio-label-content {\n  padding-left: 4px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/atoms/user-type/user-type.component.scss
// module id = ./src/app/components/atoms/user-type/user-type.component.scss
// module chunks = main